import { render, staticRenderFns } from "./ServiceDetail.vue?vue&type=template&id=db74b1a6&scoped=true"
import script from "./ServiceDetail.vue?vue&type=script&lang=js"
export * from "./ServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./ServiceDetail.vue?vue&type=style&index=0&id=db74b1a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db74b1a6",
  null
  
)

export default component.exports